import sponsor1 from '../../../../assets/sponsors/s-1.png'
import sponsor2 from '../../../../assets/sponsors/s-2.png'

const Sponsor = () => {
    return (

        <fieldset className="max-w-screen-xs md:max-w-screen-lg text-center my-10 mx-auto p-5 md:p-10 border-slate-800 dark:border-white border-4 dark:text-white">
            <legend className="dark:text-white font-[blanka] text-3xl mb-10">Sponsors</legend>
            <div className=' md:flex justify-evenly'>
                <a href="https://www.youtube.com/@TatsTopVideos" rel="noreferrer" target='_blank'>
                    <img className='md:max-w-md max-w-xs' src={sponsor1} alt="" />
                </a>
                <a href="https://www.dubby.gg/discount/STUDIOMERCY?ref=AV_-Vj3KhRj1G" rel="noreferrer" target='_blank'>
                    <img className='md:max-w-md max-w-xs' src={sponsor2} alt="" />
                </a>
            </div>
        </fieldset>
    )
}

export default Sponsor